<template>

    <div id="login-window">

        <h1 class="text-center">Logg inn</h1>

        <b-form v-if="!showForgotPin && !showForgotCardId" @submit="onSubmit" class="mb-3">
            <b-form-group >
                <b-form-input type="text" name="cardId" v-model="form.cardId" placeholder="Kort ID" trim/>
            </b-form-group>
            <b-form-group   >
                <b-form-input type="password" name="pin" v-model="form.pin" placeholder="PIN" trim/>
            </b-form-group>

            <b-alert show variant="danger" v-if="errors.length" class="errors">

                <ul>
                    <li  v-for="error in errors" :key="error">
                        {{ error }}
                    </li>
                </ul>


            </b-alert>

            <div class="d-flex align-items-center justify-content-between">
                <b-button type="submit" variant="primary">Kjør på!</b-button>
                <div>
                    <b-button variant="link" @click="showForgotPin = true">Glemt PIN?</b-button>
                    <b-button variant="link" @click="showForgotCardId = true">Glemt kort ID?</b-button>
                </div>
            </div>
        </b-form>

        <div v-else-if="showForgotPin">
            <p>Skriv inn kortnummeret ditt, så sender vi PIN-koden din på SMS.</p>
            <b-form @submit="onForgotPinSubmit" class="mb-3">
                <b-form-group>
                    <b-form-input type="text" v-model="forgotPinCardId" placeholder="Kort ID" trim/>
                </b-form-group>

                <b-alert show variant="danger" v-if="forgotPinError" class="errors">
                    {{ forgotPinError }}
                </b-alert>

                <b-alert show variant="success" v-if="forgotPinSuccess">
                    {{ forgotPinSuccess }}
                </b-alert>

                <div class="d-flex align-items-center justify-content-between">
                    <b-button type="submit" variant="primary" :disabled="forgotPinLoading">Send PIN på SMS</b-button>
                    <b-button variant="link" @click="showForgotPin = false">Tilbake til innlogging</b-button>
                </div>
            </b-form>
        </div>

        <div v-else-if="showForgotCardId">
            <p>Skriv inn telefonnummeret eller e-posten din, så sender vi kortnummeret ditt på SMS.</p>
            <b-form @submit="onForgotCardIdSubmit" class="mb-3">
                <b-form-group>
                    <b-form-input type="text" v-model="forgotCardIdContact" placeholder="Telefonnummer eller e-post" trim/>
                </b-form-group>

                <b-alert show variant="danger" v-if="forgotCardIdError" class="errors">
                    {{ forgotCardIdError }}
                </b-alert>

                <b-alert show variant="success" v-if="forgotCardIdSuccess">
                    {{ forgotCardIdSuccess }}
                </b-alert>

                <div class="d-flex align-items-center justify-content-between">
                    <b-button type="submit" variant="primary" :disabled="forgotCardIdLoading">Send kort ID på SMS</b-button>
                    <b-button variant="link" @click="showForgotCardId = false">Tilbake til innlogging</b-button>
                </div>
            </b-form>
        </div>


    </div>

</template>

<script>

export default {
    name: 'LoginWindow',
    data() {
        return {
            form: {
                cardId: process.env.VUE_APP_TEST_CARD_ID ? process.env.VUE_APP_TEST_CARD_ID : '',
                pin: process.env.VUE_APP_TEST_CARD_PIN ? process.env.VUE_APP_TEST_CARD_PIN : '',
            },
            errors: [],
            messages: {
                register: false,
            },
            showForgotPin: false,
            forgotPinCardId: '',
            forgotPinError: '',
            forgotPinSuccess: '',
            forgotPinLoading: false,
            showForgotCardId: false,
            forgotCardIdContact: '',
            forgotCardIdError: '',
            forgotCardIdSuccess: '',
            forgotCardIdLoading: false,
        }

    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault()

            // Validation
            this.errors = []
            this.messages.register = false;

            if (!this.form.cardId) this.errors.push('Kornummer mangler.')
            if (!this.form.pin) this.errors.push('PIN mangler.')


            if (this.errors.length == 0) {

                this.loginUser();

            }
        },
        onForgotPinSubmit(evt) {
            evt.preventDefault()
            this.forgotPinError = ''
            this.forgotPinSuccess = ''

            if (!this.forgotPinCardId) {
                this.forgotPinError = 'Kortnummer mangler.'
                return
            }

            this.forgotPinLoading = true

            this.$api.get(`/forgot/pin/${this.forgotPinCardId}/`)
                .then(() => {
                    this.forgotPinSuccess = 'PIN-kode er sendt til ditt telefonnummer.'
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.error) {
                        this.forgotPinError = error.response.data.error.description
                    } else {
                        this.forgotPinError = 'En feil oppstod. Kontakt support.'
                    }
                })
                .finally(() => {
                    this.forgotPinLoading = false
                })
        },
        onForgotCardIdSubmit(evt) {
            evt.preventDefault()
            this.forgotCardIdError = ''
            this.forgotCardIdSuccess = ''

            if (!this.forgotCardIdContact) {
                this.forgotCardIdError = 'Telefonnummer eller e-post mangler.'
                return
            }

            this.forgotCardIdLoading = true

            this.$api.post('/forgot/card/', { contact: this.forgotCardIdContact })
                .then(() => {
                    this.forgotCardIdSuccess = 'Kortnummer er sendt til ditt telefonnummer.'
                })
                .catch((error) => {
                    if (error.response && error.response.data && error.response.data.error) {
                        this.forgotCardIdError = error.response.data.error.description
                    } else {
                        this.forgotCardIdError = 'En feil oppstod. Kontakt support.'
                    }
                })
                .finally(() => {
                    this.forgotCardIdLoading = false
                })
        },
        loginUser() {
            this.$api.post('/login/', {}, {
                auth: {
                    username: this.form.cardId,
                    password: this.form.pin
                }
            })
            .then((response) => {
                this.$store.setToken(response.data.token);
                this.$store.setUser(response.data.user)

                this.$api.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token;


                this.$router.replace('/').catch((e) => {console.log(e)});;
            })
            .catch((error) => {

                if (error.response) {
                    let code = error.response.status;
                    let data = error.response.data;

                    if (code == 401) {
                        this.errors.push('Du har tastet inn feil kortnummer eller PIN.')
                    }
                    else if (code == 404) {
                        this.errors.push('Bruker ikke funnet.')
                    }
                    else if (code == 403) {
                        this.errors.push(data.error.description);
                    }
                    else {
                        this.errors.push('En ukjent feil har oppstått. Kontakt support.')
                    }
                }
                else {
                    this.errors.push('En ukjent feil har oppstått. Kontakt support.')
                }
            });

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

h1 {
    margin-bottom: 1em;
}

.login .errors ul {
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
}

.login .logo {
    max-width: 100px;
    margin-bottom: 2em;
}

</style>
